import React, { useState } from "react";
import axios from "axios";
import toast from "react-hot-toast";
import Card from "components/card";
import { API_BASE_URL } from "../../../../config";

const ChangePassword = () => {
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const token = localStorage.getItem("token");

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!oldPassword || !newPassword || !confirmPassword) {
      return toast.error("All fields are required");
    }

    if (newPassword !== confirmPassword) {
      return toast.error("Confirm password must match new password");
    }

    setLoading(true);
    try {
      const res = await axios.post(
        `${API_BASE_URL}/api/admin/admin-changePassword`,
        { oldPassword, newPassword, confirmPassword },
        { headers: { token } }
      );

      if (res.data.success) {
        toast.success(res.data.message);
        setOldPassword("");
        setNewPassword("");
        setConfirmPassword("");
      } else {
        toast.error(res.data.message || "Password change failed");
      }
    } catch (err) {
      toast.error("Something went wrong");
      // console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card extra="w-full p-6">
      <h2 className="text-xl font-semibold text-navy-700 dark:text-white mb-4">
        Change Password
      </h2>
      <form className="space-y-4" onSubmit={handleSubmit}>
        <div>
          <label className="text-sm font-medium text-gray-700 dark:text-white">
            Old Password
          </label>
          <input
            type="password"
            value={oldPassword}
            onChange={(e) => setOldPassword(e.target.value)}
            className="mt-1 w-full rounded-md border border-gray-300 p-2 text-sm dark:bg-navy-700 dark:text-white"
            required
          />
        </div>
        <div>
          <label className="text-sm font-medium text-gray-700 dark:text-white">
            New Password
          </label>
          <input
            type="password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            className="mt-1 w-full rounded-md border border-gray-300 p-2 text-sm dark:bg-navy-700 dark:text-white"
            required
          />
        </div>
        <div>
          <label className="text-sm font-medium text-gray-700 dark:text-white">
            Confirm New Password
          </label>
          <input
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            className="mt-1 w-full rounded-md border border-gray-300 p-2 text-sm dark:bg-navy-700 dark:text-white"
            required
          />
        </div>
        <button
          type="submit"
          disabled={loading}
          className="w-full rounded-md bg-blue-500 py-2 text-white hover:bg-blue-600 transition disabled:opacity-50"
        >
          {loading ? "Changing..." : "Change Password"}
        </button>
      </form>
    </Card>
  );
};

export default ChangePassword;
